import { Boxes, Clipboard } from "lucide-react";
import { toast } from "sonner";
import { InteractionTimeline } from "./InteractionTimeline";
import { useInteractions } from "./useInteractions";
import type { Lead } from "./types";

function CopyId({ label, value }: { label: string; value: string }) {
  return (
    <span className="inline-flex items-center gap-1.5">
      {label}
      <code className="rounded bg-muted px-1.5 py-0.5 font-mono text-[11px]">
        {value.slice(0, 8)}
      </code>
      <button
        type="button"
        aria-label={`复制${label} ID`}
        title={`复制${label} ID`}
        className="inline-flex size-5 items-center justify-center rounded text-muted-foreground transition hover:bg-muted hover:text-foreground"
        onClick={() => {
          void navigator.clipboard.writeText(value).then(() => {
            toast.success(`${label} ID 已复制`);
          });
        }}
      >
        <Clipboard className="size-3" />
      </button>
    </span>
  );
}

export function LeadEditExtras({
  lead,
  leads,
  directory,
  currentUserId,
  onViewContact,
}: {
  lead: Lead;
  leads: Lead[];
  directory: { id: string; username: string }[];
  currentUserId?: string;
  onViewContact: () => void;
}) {
  const { interactions, add, remove } = useInteractions(lead.id);
  const usernameOf = (userId: string) =>
    directory.find((user) => user.id === userId)?.username ??
    (userId ? userId.slice(0, 8) : "—");
  const contactLeadCount = lead.contact_id
    ? leads.filter((item) => item.contact_id === lead.contact_id).length
    : 0;

  return (
    <div className="mt-4 border-t pt-4">
      <div className="flex flex-wrap items-center gap-x-4 gap-y-1.5 text-xs text-muted-foreground">
        <CopyId label="货盘" value={lead.id} />
        {lead.contact_id ? (
          <CopyId label="货主" value={lead.contact_id} />
        ) : (
          <span>货主 ID 未分配</span>
        )}
        {lead.contact_id && (
          <button
            type="button"
            className="inline-flex items-center gap-1.5 rounded-md px-2 py-1 font-medium transition hover:bg-muted hover:text-foreground"
            onClick={onViewContact}
          >
            <Boxes className="size-3.5" />
            该货主全部货盘（{contactLeadCount}）
          </button>
        )}
      </div>
      <InteractionTimeline
        interactions={interactions}
        currentUserId={currentUserId}
        usernameOf={usernameOf}
        onAdd={add}
        onDelete={remove}
      />
    </div>
  );
}
